export const nextLetter = (array) => {
  if (array.length === 0) {
    return undefined; // Si el array está vacío, retorna undefined
  }

  // Función para calcular la siguiente letra
  function siguienteLetra(letra) {
    const longitud = letra.length;
    const resultado = [];
    let carry = true;

    // Recorremos la cadena de derecha a izquierda para encontrar el "carry"
    for (let i = longitud - 1; i >= 0; i--) {
      if (carry) {
        if (letra[i] === 'Z') {
          resultado.unshift('A'); // Si es 'Z', se convierte en 'A'
        } else {
          resultado.unshift(String.fromCharCode(letra.charCodeAt(i) + 1)); // Sumar 1 al código de la letra
          carry = false; // Termina el "carry"
        }
      } else {
        resultado.unshift(letra[i]); // Copiar el resto de la letra sin cambios
      }
    }

    // Si queda un "carry", agregamos una 'A' al principio
    if (carry) {
      resultado.unshift('A');
    }

    return resultado.join(''); // Convertimos el array en una cadena de nuevo
  }

  // Encontramos la letra mayor en el array
  const mayor = array.reduce((max, current) => current > max ? current : max);

  // Devolvemos la siguiente letra de la mayor
  return siguienteLetra(mayor);
}
